import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const SexChoices = [
  { label: l`global.male`, id: "MALE" },
  { label: l`global.female`, id: "FEMALE" }
]

export default SexChoices
